// extracted by mini-css-extract-plugin
export var infoSection = "_i-1";
export var infoSectionContainer = "_i-0";
export var infoSectionTitleRow = "_i-2";
export var multiLineInfo = "_i-4";
export var strong = "_i-3";